// Copyright © 2024 The Things Industries B.V.

// News.

export const selectNewsStore = state => state.news
export const selectNewsItemsStore = state => selectNewsStore(state).items
